export const initCalendarConfig = () => {
  return { type: "INIT_CALENDAR_SETTINGS" };
};

export const setCalendarSelectedDays = selectedDays => {
  return {
    type: "SET_CALENDAR_SELECTED_DAYS",
    selectedDays
  };
};

export const setCalendarSelectedFiles = selectedFiles => {
  return {
    type: "SET_CALENDAR_SELECTED_FILES",
    files: selectedFiles
  };
};

export const setTeamCalendarYear = year => {
  return {
    type: "SET_CALENDAR_YAER",
    year
  };
};

export const setCalendarActivatedOption = activatedOption => {
  return {
    type: "SET_CALENDAR_ACTIVATED_OPTION",
    activatedOption
  };
};

export const setCalendarModifiers = modifiers => {
  return {
    type: "SET_CALENDAR_MODIFIERS",
    modifiers
  };
};

export const initCalendarSelect = () => {
  return { type: "INIT_CALENDAR_SELECT" };
};

export const setCalendarPlanning = planning => {
  return {
    type: "SET_CALENDAR_PLANNING",
    planning
  };
};
export const setCalendarId = id => {
  return {
    type: "SET_CALENDAR_ID",
    id
  };
};

export const saveCalendarSettings = resp => ({
  type: "SAVE_CALENDAR_SETTINGS",
  payload: resp
});

export const getCalendarSettings = payload => {
  return {
    type: "FETCH_CALENDAR_SETTINGS",
    payload
  };
};



// WEBPACK FOOTER //
// ./src/actions/actions/calendar-settings.js